import { render, staticRenderFns } from "./SpecificRequestReviewer.vue?vue&type=template&id=acffe3c6&scoped=true&"
import script from "./SpecificRequestReviewer.vue?vue&type=script&lang=js&"
export * from "./SpecificRequestReviewer.vue?vue&type=script&lang=js&"
import style0 from "./SpecificRequestReviewer.vue?vue&type=style&index=0&id=acffe3c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acffe3c6",
  null
  
)

export default component.exports